export enum CreditStatus {
  Ok = 'Ok',
  Hold = 'Hold',
  Warn = 'Warn'
}
